var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.matchInfo.isShowGame === 'SHOW')?_c('div',[_c('DefaultGame')],1):_c('div',{staticClass:"content",staticStyle:{"margin-top":"50px","height":"100px"}},[_c('a-empty',{attrs:{"image":_vm.hiddenImg,"image-style":{height: '30px'}}},[_c('span',{staticStyle:{"color":"#bbbaba"},attrs:{"slot":"description"},slot:"description"})])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31342d99","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/comm/components/MatchGame.vue
// module id = null
// module chunks = 